import { render, staticRenderFns } from "./MraSancoesAdmTable.vue?vue&type=template&id=c10399d8&scoped=true&lang=pug"
import script from "./MraSancoesAdmTable.vue?vue&type=script&lang=js"
export * from "./MraSancoesAdmTable.vue?vue&type=script&lang=js"
import style0 from "./MraSancoesAdmTable.vue?vue&type=style&index=0&id=c10399d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10399d8",
  null
  
)

export default component.exports